import React from "react";
import LayoutHOC from "../LayoutHOC";

const UserMyTeam = () => {
  return <div>My Team</div>;
};

export default UserMyTeam;
